<script>
import Form from 'element-ui/lib/form';

export default Form;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/form.css';
@import '../../stylesheets/utils/utils';
// Adding RTL support to element's form

.el-form {
  $form: &;

  &--label-top {
    padding-bottom: 0;

    #{$form}-item {
      &__label {
        padding-bottom: 0;
      }
    }
  }
}
</style>
